import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";

function SectionLabel({ num, title }) {
  return (
    <div style={{ marginBottom: "1rem", paddingLeft: "clamp(0px, 15vw, 4.5rem)" }}>
      <div style={{ fontFamily: FONT_MONO, fontSize: "0.72rem", color: C.accentBorder, letterSpacing: "4px", marginBottom: "0.6rem" }}>
        {num + " ───────────"}
      </div>
      <h2 style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "clamp(1.3rem,4vw,2.6rem)", color: "#fff" }}>
        {title}
      </h2>
    </div>
  );
}

export default function Certifications() {
  return (
    <div className="anim-fadeup" style={{ padding: "4rem clamp(1.5rem,5vw,4rem)", maxWidth: "900px", margin: "0 auto" }}>
      <SectionLabel num="04" title="Certifications" />

      <div style={{ height: "1px", background: `linear-gradient(90deg, ${C.accentBorder}, transparent)`, marginBottom: "3rem", marginLeft: "clamp(0px, 15vw, 4.5rem)" }} />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px,1fr))", gap: "1.25rem" }}>
        {DATA.certifications.map(cert => (
          <div key={cert.name} className="card-lift" style={{
            background: C.card, border: `1px solid ${C.cardBorder}`,
            borderRadius: "10px", padding: "1.75rem", textAlign: "center",
          }}>
            <div style={{
              width: "56px", height: "56px", borderRadius: "50%",
              background: cert.accent + "18", border: `2px solid ${cert.accent}`,
              margin: "0 auto 1.2rem",
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem",
            }}>
              🎖️
            </div>
            <div style={{ fontFamily: FONT_HEAD, fontWeight: 700, fontSize: "0.98rem", color: "#fff", marginBottom: "0.35rem" }}>
              {cert.name}
            </div>
            <div style={{ fontFamily: FONT_MONO, color: cert.accent, fontSize: "0.75rem", marginBottom: "0.3rem" }}>
              {cert.issuer}
            </div>
            <div style={{ fontFamily: FONT_MONO, color: C.faint, fontSize: "0.7rem" }}>{cert.year}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
